"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next */
var debug = typeof process === 'undefined' || typeof process.env.RLAYERS_DEBUG === 'undefined'
    ? function () { return undefined; }
    : // eslint-disable-next-line no-console
        console.debug.bind(window.console);
exports.default = debug;
//# sourceMappingURL=debug.js.map